import React, { useEffect, useState } from "react";
import TPAList from "../../containers/TPA_MedicalScheduling/TPAList";
const TPADetails = (props) => {
  const seedData = [
    {
      name: "Waived Off By",
      value: "",
      key: "waivedOffBy",
      show: true,
    },
    {
      name: "TPA Waive Off Type",
      value: "",
      key: "tpaWaiveOffType",
      show: true,
    },
    {
      name: "TPA Waive Off For Proposer",
      value: "",
      key: "tpaWaiveOffForProposer",
      show: true,
    },
    {
      name: "TPA Waive Off For Insured",
      value: "",
      key: "tpaWaiveOffForInsured",
      show: true,
    },
    {
      name: "TPA Waive Off For Both",
      value: "",
      key: "tpaWaiveOffForBoth",
      show: true,
    },
    {
      name: "Reason for Waiving Medicals (Proposer)",
      value: "",
      key: "tpaDocumentWaiveOffReasonForProposer",
      show: true,
    },
    {
      name: "Reason for Waiving Medicals (Insured)",
      value: "",
      key: "tpaDocumentWaiveOffReasonForInsured",
      show: true,
    },
    // {
    //   name: "Created On",
    //   value: "",
    //   key: "audit.createdOn",
    //   show: true,
    // },
    // {
    //   name: "Updated On",
    //   value: "",
    //   key: "audit.updatedOn",
    //   show: true,
    // },
  ];
  // const tpaWaiveOffDetails = {
  //   waivedOffBy: "waivedOffBy_044ef4ae6982",
  //   tpaWaiveOffType: "WAIVE_OFF_MEDICALS",
  //   TpaWaiveOffForProposer: false,
  //   TpaWaiveOffForInsured: true,
  //   TpaWaiveOffForBoth: false,
  // };


  const [initialdata, setData] = useState(seedData);
  useEffect(() => {
    const { tpaWaiveOffDetails
    } = props.proposalData;
    console.log('tpaWaiveOffDetails', tpaWaiveOffDetails)
    let data = seedData.map((item) => {
      if (tpaWaiveOffDetails?.hasOwnProperty(item.key)) {
        return { ...item, value: tpaWaiveOffDetails[item.key] };
      }
      return item;
    }, [props.proposalData]);
    setData(data);
  }, [props.proposalData]);
  return (
    <div className="main_container">
      <TPAList initialdata={initialdata} proposalData={props.proposalData} TPAData={props.TPAData} />
    </div>
  );
};

export default TPADetails;
